/* weaintboyz: scroll reveals, book flip and hero parallax for the wab-* sections. */
(() => {
  if (window.__wab) return;
  window.__wab = true;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('wab-js');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  const init = (root = document) => {
    root.querySelectorAll('[data-wab-reveal]:not(.is-in)').forEach((el) => observer.observe(el));

    root.querySelectorAll('[data-wab-flip]').forEach((button) => {
      if (button.dataset.wabReady) return;
      button.dataset.wabReady = 'true';
      button.addEventListener('click', () => {
        button.setAttribute('aria-pressed', String(button.getAttribute('aria-pressed') !== 'true'));
      });
    });
  };

  // Hero image drifts slightly slower than the page while it is on screen.
  let ticking = false;
  const parallax = () => {
    document.querySelectorAll('[data-wab-parallax]').forEach((el) => {
      const rect = el.parentElement.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      el.style.transform = `translate3d(0, ${Math.round(rect.top * -0.18)}px, 0)`;
    });
    ticking = false;
  };
  if (!reduced) {
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(parallax);
    }, { passive: true });
  }

  init();
  // Theme editor: re-run when a section is added or re-rendered.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
